import { async } from 'regenerator-runtime';

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

export const get_JSON = async function (url) {
  try {
    const rec = await Promise.race([fetch(url), timeout(10)]);
    const recData = (await rec).json();

    if (!rec.ok) throw new Error(` ${recData.message},(${rec.status})`);
    return recData;
  } catch (err) {
    throw err;
  }
};
export const send_JSON = async function (url, uploadData) {
  try {
    const fetchPro = fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(uploadData),
    });

    const rec = await Promise.race([fetchPro, timeout(10)]);
    const recData = (await rec).json();

    if (!rec.ok) throw new Error(` ${recData.message},(${rec.status})`);
    return recData;
  } catch (err) {
    throw err;
  }
};
